import React from 'react';

import { LoaderContainer } from './Loader.styled';
import theme from 'kb-shared/theme';
import { AbsoluteCentered } from 'styled/shared';

import { Props } from './Loader.types';
import { Spinner } from './Spinner';

export const Loader = ({
  color = theme.colors.yellow.primary,
  type = 'spin',
  width = 150,
  height = 150,
  className = '',
  container = false,
  absoluteCentered = false
}: Props): React.JSX.Element => {
  const LoaderComponent = (
    <Spinner type={type} color={color} className={className} width={width} height={height} />
  );

  if (absoluteCentered) return <AbsoluteCentered>{LoaderComponent}</AbsoluteCentered>;

  return container ? <LoaderContainer>{LoaderComponent}</LoaderContainer> : LoaderComponent;
};
